<i18n>
{
	"no": {
		"messageCreationError" : "Feil ved generering av melding",
		"sendingErrors": "Feil ved sending av melding"
	},
	"en": {
		"messageCreationError" : "Error generating message",
		"sendingErrors": "Errpr sending message"
	}

}

</i18n>
<template>
	<div>
		<t-text-area
			:label="$t('messageCreationError')"
			height="500px"
			resize="none"
			:value="messageCreationError"
		/>

		<t-text-area
			:label="$t('sendingErrors')"
			height="500px"
			resize="none"
			:value="sendingError"
		/>
	</div>
</template>

<script>


import { mapGetters } from './store/outbound.store.js';

export default {

	computed: {

		...mapGetters(['getTransmissionDetails']),

		messageCreationError() {
			let messageCreationErrors  = this.getTransmissionDetails.messageCreationError;
			if (messageCreationErrors)
				return JSON.stringify(messageCreationErrors, null, 2);
			return '';
		},
		sendingError() {
			let { sendingErrors } = this.getTransmissionDetails;
			if (sendingErrors)
				return JSON.stringify(sendingErrors, null, 2);
			return '';
		}
	}
};
</script>

<style>

</style>